import { ErrorMessage } from './error-message.enum';
const defaultErrorContext = { enabled: true, level: 'error' };
export class WidgetError extends Error {
    constructor(id, contexts) {
        var _a, _b;
        const errorMessage = (_b = (_a = contexts === null || contexts === void 0 ? void 0 : contexts.originalError) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : '';
        super(`WidgetError: "${id}" ${errorMessage}`);
        this.name = 'WidgetError';
        this.contexts = contexts;
    }
}
export class VideoError extends Error {
    constructor(message, contexts) {
        var _a;
        const videoSource = (_a = contexts === null || contexts === void 0 ? void 0 : contexts.src) !== null && _a !== void 0 ? _a : '';
        super(`VideoError: ${message} ${videoSource}`);
        this.name = 'VideoError';
    }
}
export function getVideoErrorMessage(code) {
    switch (code) {
        case MediaError.MEDIA_ERR_ABORTED:
            return ErrorMessage.MediaErrorAborted;
        case MediaError.MEDIA_ERR_NETWORK:
            return ErrorMessage.MediaErrorNetwork;
        case MediaError.MEDIA_ERR_DECODE:
            return ErrorMessage.MediaErrorDecode;
        case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
            return ErrorMessage.MediaErrorSourceNotSupported;
        default:
            return '';
    }
}
function isErrorContext(value) {
    return !!(value && value.contexts);
}
export function handleError(message, context) {
    let errorContext;
    if (!isErrorContext(context)) {
        errorContext = Object.assign(Object.assign({}, defaultErrorContext), { contexts: { context } });
    }
    else {
        errorContext = Object.assign(Object.assign({}, defaultErrorContext), context);
    }
    if (errorContext.level === 'error') {
        const unwrappedContext = errorContext.contexts ? Object.values(errorContext.contexts) : [];
        // Studio Client global-error-handler
        const tracker = globalThis === null || globalThis === void 0 ? void 0 : globalThis.globalErrorHandler;
        if (errorContext.enabled && tracker) {
            const firstError = unwrappedContext.find(error => error instanceof Error);
            tracker.handleError(firstError !== null && firstError !== void 0 ? firstError : message);
        }
        else {
            console.error(message, ...unwrappedContext);
        }
    }
    else {
        console.warn(message, errorContext.contexts);
    }
}
